"use strict";
/*************************************************************************
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: Adobe permits you to use, modify, and distribute this file in
 * accordance with the terms of the Adobe license agreement accompanying
 * it. If you have received this file from a source other than Adobe,
 * then your use, modification, or distribution of it requires the prior
 * written permission of Adobe.
 **************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.SANDBOX_TYPES = exports.PROVIDERS = void 0;
/**
 * The Feature Flags API provides feature flag data from LaunchDarkly and Floodgate.
 *
 * To consume this API, add the following import to your code.
 *
 * ```typescript
 * import featureFlags from '@adobe/exc-app/featureflags';
 * ```
 *
 * The default export is an object of type [FeatureFlagsApi](../interfaces/_featureflags_.featureflags.md)
 *
 * API reference: [scroll down](#index)
 *
 * ### Sample code
 *
 * ```typescript
 * import featureFlags from '@adobe/exc-app/featureflags';
 *
 * const featureFlags = await featureFlags.get(['cjm', 'experience-platform']);
 * ```
 *
 * Feature flags can also be requested from Floodgate by:
 * - including the provider in the options
 * - including the clientIds in the options (instead of projectIds)
 * If no provider is specified, the default provider is LaunchDarkly.
 *
 * ```typescript
 * import featureFlags, {PROVIDERS} from '@adobe/exc-app/featureflags';
 *
 * const floodgateFlags = await featureFlags().get({clientIds: ['unified-shell'], provider: PROVIDERS.FLOODGATE});
 * ```
 *
 * All feature flags can be requested using the key '*'
 * ```typescript
 * import featureFlags, {PROVIDERS} from '@adobe/exc-app/featureflags';
 *
 * const featureFlags = await featureFlags.get(['*']);
 *
 * const featureFlags = await featureFlags.get({clientIds: ['*'], provider: PROVIDERS.FLOODGATE});
 *
 * ```
 * In some cases you may want to include context options that are not already
 * included in the current app's active context. For example, requesting feature
 * flags for a project that uses sandboxes from an app that does not.
 *
 * To include options in the request, pass an object with the projectIds or clientIds and the context options.
 *
 * ```typescript
 * import featureFlags from '@adobe/exc-app/featureflags';
 *
 * const sandbox = {name: 'name'};
 * const featureFlags = await featureFlags.get({projectsIds: ['cjm'], sandbox});
 * ```
 *
 * API for fetching app data.
 * @packageDocumentation
 * @module featureflags
 */
var PROVIDERS;
(function (PROVIDERS) {
    PROVIDERS["FLOODGATE"] = "Floodgate";
    PROVIDERS["LAUNCH_DARKLY"] = "Launch Darkly";
})(PROVIDERS = exports.PROVIDERS || (exports.PROVIDERS = {}));
var SANDBOX_TYPES;
(function (SANDBOX_TYPES) {
    SANDBOX_TYPES["development"] = "DEVELOPMENT";
    SANDBOX_TYPES["production"] = "PRODUCTION";
})(SANDBOX_TYPES = exports.SANDBOX_TYPES || (exports.SANDBOX_TYPES = {}));
const Global_1 = require("./src/Global");
const featureFlags = {
    get: (params) => {
        return (0, Global_1.getImpl)('featureFlags')().get(params);
    }
};
exports.default = featureFlags;
//# sourceMappingURL=featureflags.js.map